export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,
            classes: ['swiper-wrapper'],
            attributes:{
                "data-slg-type":"C-FORM-SWIPER-WRAPPER"
            }
        }
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-FORM-SWIPER-WRAPPER")
                return { type:'C-FORM-SWIPER-WRAPPER' }
        }
    });

    var view = VIEW.extend({
        onRender() {
            let slides = this.model.components();
            for (let i = 0; i < slides.length; i++) {
                const slide = slides.at(i);
                slide.setStyle({
                    display: (i == 0) ? "block":"none"
                })
            }
        },
    });

    DOMC.addType('C-FORM-SWIPER-WRAPPER', {
      model:model,
      view:view,
    });

};
  